<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <b-modal v-model="modalActive" scroll="keep" width="90%">
      <div class="is-flex is-flex-direction-column" style="height: 100%;width: 100%">
        <div class="is-flex">
          <div class="block ml-auto mr-auto">
              <b-radio v-model="selectedSpeed"
                       @input="onSpeedChanged"
                       type="is-white"
                       name="name"
                       class="mr-4"
                       :native-value="1">x1</b-radio>
              <b-radio v-model="selectedSpeed"
                       @input="onSpeedChanged"
                       type="is-white"
                       name="name"
                       class="mr-4"
                       :native-value="2">x2</b-radio>
              <b-radio v-model="selectedSpeed"
                       @input="onSpeedChanged"
                       type="is-white"
                       name="name"
                       class="mr-4"
                       :native-value="3">x3</b-radio>
              <b-radio v-model="selectedSpeed"
                       @input="onSpeedChanged"
                       type="is-white"
                       name="name"
                       class="mr-4"
                       :native-value="4">x4</b-radio>
            <b-radio v-model="selectedSpeed"
                     @input="onSpeedChanged"
                     type="is-white"
                     name="name"
                     :native-value="8">x8</b-radio>
            </div>
        </div>
        <video id="vid" ref="videoRef"
               controls
               :src="src"
               @loadedmetadata="onVideoMetaDataLoaded" loop=""
               preload="auto"
               class="m-auto"
               muted="" style="height: 90%; min-width: 30vw; background: black"></video>
      </div>

    </b-modal>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "video-preview-modal",
  components: {},
  data() {
    return {
      isLoading: false,
      modalActive: false,
      src: null,
      selectedSpeed: 1
    }
  },
  mounted() {

  },
  methods: {
    onSpeedChanged(speed){
      console.log('Speed changed: ', speed)
      this.$refs.videoRef.playbackRate = speed
    },
    async show(show, videoUrl) {
      this.modalActive = show
      console.log('Modal video url: ', videoUrl)
      console.log('Selected speed: ', this.selectedSpeed)
      setTimeout(()=>{
        if(show){
          this.$refs.videoRef.playbackRate = this.selectedSpeed
          this.src = videoUrl
        }
      }, 1000)

    },
    onVideoMetaDataLoaded(e) {
      this.isLoading = false
    },
    async onCloseClicked() {
      console.log('On save Payload', this.payload)
      await this.show(false, null)
    },
  },
  computed: {
    ...mapGetters({
      selectedDevice: 'dataProcessingModule/getSelectedProcessingDevice'
    }),
  }
}
</script>

<style scoped lang="scss">

.b-radio.radio {
  color: white !important;
}
</style>